module.exports = __webpack_public_path__ + "static/TitilliumWeb-SemiBoldItalic-e45171fcba2c128c824e799d202cc69c.woff2";